import $ from 'jquery';
import { initFocusModality } from './helpers/focusModality';

// Components
import * as carousels from './components/desktop/carousels';
import * as gaPrint from './components/desktop/gaPrint';
import * as rowClick from './components/desktop/rowClick';
import * as tabs from './components/desktop/tabs';
import * as contentTables from './components/mobile/contentTables';

// content load components
const componentsload = [];

// once delegated components
const components = [carousels, gaPrint, rowClick, tabs, contentTables].concat(componentsload);

// window.AppDesktop = {
// 	run() {
initFocusModality();

var $target = $(document);
components.forEach((component) => component.init($target));

$(document).on('contentload', function (event) {
    var $target = $(event.target);
    componentsload.forEach((component) => component.init($target));
});
// 	},
